import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SrMappingRoutingModule} from './sr-mapping-routing.module';
import {SrMappingComponent} from './sr-mapping.component';
import {AddSrMappingComponent} from './add-sr-mapping/add-sr-mapping.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [SrMappingComponent, AddSrMappingComponent],
    imports: [
        CommonModule,
        SrMappingRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [SrMappingComponent, AddSrMappingComponent]
})
export class SrMappingModule {
}
